import React, { Component } from 'react';

import ReactHtmlParser from 'react-html-parser';

import FrontHeader from '../views/frontend/Header/Header';
import Footer from '../views/frontend/Footer/Footer';

import {designCenterActions}    from '../redux/actions/designCenterActions';
import isEmpty from "lodash.isempty";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
let isLoading = false;
let headTag = 0;

class PublicLayout extends Component {

  constructor(props, context){
    super(props, context);
    this.state = {
      cartStatus:'',
      themeData: '',
      backgroundStyles: {},
      mapKey:'',
    };
    this.handleSearch=this.handleSearch.bind(this);
  }

  componentDidMount(){
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(this.props.route.match.path != '/deals-detail/:dealID?'){
      if(siteData && siteData.seo_settings.meta_description){
        document.title = (siteData && siteData.seo_settings.site_title) ? siteData.seo_settings.site_title : 'Payvibe';
        let meta = document.querySelector("meta[name*='description']");
        meta.content = siteData.seo_settings.meta_description;
      }

      if(!document.querySelector("meta[name*='keywords']") && siteData && siteData.seo_settings.meta_keywords){
        const keyword = document.createElement("meta");
        keyword.name="keywords";
        keyword.content = siteData.seo_settings.meta_keywords;
        document.head.appendChild(keyword);
      }

      if(siteData && siteData.seo_settings.analytics_tracking_code_head && headTag === 0){
        headTag = 1;
        document.head.innerHTML += siteData.seo_settings.analytics_tracking_code_head;
      }

      if(!document.querySelector("div[id*='analytic']") && siteData && siteData.seo_settings.analytics_tracking_code_body){
        const div = document.createElement("div");
        div.id = "analytic";
        document.body.appendChild(div);
        document.getElementById('analytic').innerHTML = siteData.seo_settings.analytics_tracking_code_body;
      }

    }
    const { actions: { getThemeData } } = this.props;
    let defaultCity;
    if(siteData){
      if(siteData.default_city){
        defaultCity = siteData.default_city;
        this.setState({mapKey:(!isEmpty(siteData.api_settings) && siteData.api_settings[0].google_map_key != '') ? siteData.api_settings[0].google_map_key : '' })
      }
    }

    if(this.state.themeData == '' && !isEmpty(this.props.themeData)){
      this.setState({themeData: this.props.themeData.data});
      if(this.props.themeData.data.background.background_image){
        this.setState({
            backgroundStyles: {
              'backgroundColor': this.props.themeData.data.background.background_color,
              'backgroundImage': `url(${this.props.themeData.data.background.background_image})`,
              'backgroundPosition': 'center',
              'backgroundRepeat': (this.props.themeData.data.background.background_color) ? 'no-repeat' : 'repeat',
              'paddingBottom': '10px'
            }
        });
      }else{
        this.setState({
            backgroundStyles: {
              'backgroundColor': this.props.themeData.data.background.background_color,
              'paddingBottom': '10px'
            }
        });
      }
      
    }
    if(isEmpty(this.props.themeData) && siteData){
      getThemeData({scheduledDate:moment().format("YYYY-MM-DD HH:mm:ss"), cityID: (defaultCity) ? defaultCity : ''});
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.themeData.data){
      this.setState({
        themeData: nextProps.themeData.data
      });
      if(nextProps.themeData.data.background){
        let bgColor = nextProps.themeData.data.background.background_color;
        let bgImage = nextProps.themeData.data.background.background_image;
        let bgRepeat = (bgColor) ? 'no-repeat' : 'repeat';
        if(bgImage){
          this.setState({
            backgroundStyles: {
              'backgroundColor': bgColor,
              'backgroundImage': `url(${bgImage})`,
              'backgroundPosition': 'center',
              'backgroundRepeat': bgRepeat,
              'paddingBottom': '10px'
            }
          });
        }else{
          this.setState({
            backgroundStyles: {
              'backgroundColor': bgColor,
              'paddingBottom': '10px'
            }
          });
        }
      }
    }
  }

  onSearch  = (val) => {
    this.handleSearch(val);
  };

  handleSearch(val){
    const postData = {
      page:this.state.currentPage,
      latitude:(this.props.coords) ? this.props.coords.latitude : '26.846695',
      longitude:(this.props.coords) ? this.props.coords.longitude : '80.946167',
      search:val,
      limit:this.state.linit,
    }

    if(val.length !== 0){
      this.handlePageChange(postData);
    }
  }

  handlePageChange = page => {
    isLoading=true;
    this.setState({
      currentPage: page
    });

    const postData = {
      page:page,
      latitude:'26.846695',
      longitude:'80.946167',
      limit: this.state.limit 
    }

    let permalink = (this.props.route.match && this.props.route.match.params.permalink) ? this.props.route.match.params.permalink : '';
    if (permalink !== '')
    {
      this.setState({permalink: this.props.route.match.params.permalink })
      this.props.categoryWiseDeal(permalink)
    }

  };

  updateSiteProperties(cityID){
    if(cityID) {
      const { actions: { getThemeData } } = this.props;
      getThemeData({scheduledDate:moment().format("YYYY-MM-DD HH:mm:ss"), cityID: cityID});
    }
  }
  render() {
    const Component = this.props.component;
    const route = this.props.route;
    const user  = this.props.user;
    return (
        <React.Fragment>
        {this.state.themeData &&
          <React.Fragment>
          <FrontHeader  cartStatus={this.state.cartStatus} themeData={this.state.themeData} updateSiteProperties={this.updateSiteProperties.bind(this)} />          
          <div style={this.state.backgroundStyles}>
            <Component route={route} themeData={this.state.themeData} mapkey={this.state.mapKey} />
          </div>
          <Footer themeData={this.state.themeData} />
          </React.Fragment>
        }
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    error:  state.designCenterReducer.error,
    themeData:  state.designCenterReducer.themeData
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        ...designCenterActions,
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicLayout);



// WEBPACK FOOTER //
// ./src/app/layout/PublicLayout.js